import {ShapeCommand} from '../commands.template';

export class ActivityChangeContainerCommand extends ShapeCommand {
  services: any;
  firstAction;
  boolean;
  private container: boolean;
  constructor(data) {
    super(data);
    this.firstAction = true;
    this.container = Boolean(this.object.container);
  }

  public execute() {
    super.execute();
    const action: any = {
      changeActivity: {
        mxKey: this.object.mxKey,
        container: this.container
      }
    };

    this.services.diagramUpdateSvc.update(action);
    this.redrawActivity(this.object.mxKey);
  }

  public reverse() {
    super.reverse();
    const action: any = {
      changeActivity: {
        mxKey: this.object.mxKey,
        container: !this.container
      }
    };

    this.services.diagramUpdateSvc.update(action);
    this.redrawActivity(this.object.mxKey);
  }

  private redrawActivity(mxKey) {
    this.services.editorRegistrySvc
      .getGraph()
      .model.getCell(Number(mxKey))
      .comp.instance.setupFromJson();
  }
}
